import { InputNumber } from 'antd';
import styled from 'styled-components';
import { formatPhoneNumber } from '@/utils';

const StyledInputNumber = styled(InputNumber)`
  width: 100%;

  .ant-input-number-handler-wrap {
    display: none;
  }
`;

const PhoneInput = (props) => {
  return (
    <StyledInputNumber
      {...props}
      maxLength={14}
      formatter={formatPhoneNumber}
      parser={(str) => {
        return str.replace(/\D/g, '').substring(0, 10);
      }}
      onKeyDown={(e) => {
        if (e.key.length > 1 || /^[0-9]$/.test(e.key)) return;
        e.preventDefault();
      }}
    />
  );
};

export default PhoneInput;
